import { Skeleton, tk, verticalGap } from '@sunwebgroup/ui-components'
import { styled } from 'styled-components'

const Wrapper = styled.div`
  position: relative;
  width: 280px;
  box-shadow: ${tk('shadow_md_bottom')};
  border-radius: ${tk('radius_large')};
  background-color: ${tk('color_semantic_bg')};
  height: 100%;

  @media ${tk('mq_desktop_sm')} {
    width: 320px;
  }
`

const ProductImage = styled(Skeleton)`
  object-fit: cover;
  border-radius: ${tk('radius_large')} ${tk('radius_large')} 0px 0px;
  height: 215px;
  width: 280px;

  @media ${tk('mq_desktop_sm')} {
    width: 320px;
  }
`

const Heading = styled(Skeleton)`
  height: ${tk('typography_heading_md_size')};
  width: 70%;
`

const Footer = styled.div`
  padding: ${tk('spacing_md')};
  display: flex;
  flex-direction: column;

  ${verticalGap('spacing_xs')}
`

const SubHeading = styled(Skeleton)`
  height: ${tk('typography_body_sm_size')};
  width: 50%;
`
/**
 * @deprecated This file is deprecated and will be removed in the future.
 * TODO: To be deleted when FF ACTIVATE_UDS_SEARCH_PRODUCT_CARD is deleted.
 */
export function ProductAdLoadingLegacy() {
  return (
    <Wrapper>
      <ProductImage />
      <Footer>
        <Heading />
        <SubHeading />
      </Footer>
    </Wrapper>
  )
}
